module.exports = __webpack_public_path__ + "img/image.4936369e.svg";